import React from "react";

// Source Data
import { testimonyData } from "../../source/aboutTestimonialSource";
import { useTranslation } from "../../i18n";
export default function QuoteTestimonyComponents() {
  const { t, lang } = useTranslation();
  return (
    <div className="quote_testimony">
      <div className="quote font-vietnam-600 mb-4">
        {t.about.quote}
      </div>
      <div className="divider"></div>
      <div className="testimony mt-4">
        <div className="title font-vietnam-400 font-size-14 text-uppercase">
          {t.about.testimonialBy}
        </div>
        {testimonyData.map((item, index) => (
          <div className="content mb-2" key={index}>
            <div className="name font-size-18 font-vietnam-600">
              {item.name} - <span className="font-size-14">{item.role}</span>
            </div>
            <div className="opinion font-size-14 font-vietnam-300">
              {item.quote[lang]}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
